module.exports = __webpack_public_path__ + "static/media/steadfast-logo.ca4d0849.svg";